
      import API from "!../../webpack-config-single-spa/node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js";
      import domAPI from "!../../webpack-config-single-spa/node_modules/style-loader/dist/runtime/styleDomAPI.js";
      import insertFn from "!../../webpack-config-single-spa/node_modules/style-loader/dist/runtime/insertBySelector.js";
      import setAttributes from "!../../webpack-config-single-spa/node_modules/style-loader/dist/runtime/setAttributesWithoutAttributes.js";
      import insertStyleElement from "!../../webpack-config-single-spa/node_modules/style-loader/dist/runtime/insertStyleElement.js";
      import styleTagTransformFn from "!../../webpack-config-single-spa/node_modules/style-loader/dist/runtime/styleTagTransform.js";
      import content, * as namedExport from "!!../../webpack-config-single-spa/node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!./style.css";
      
      

var options = {};

options.styleTagTransform = styleTagTransformFn;
options.setAttributes = setAttributes;

      options.insert = insertFn.bind(null, "head");
    
options.domAPI = domAPI;
options.insertStyleElement = insertStyleElement;

var update = API(content, options);



export * from "!!../../webpack-config-single-spa/node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!./style.css";
       export default content && content.locals ? content.locals : undefined;
